import { CONVERSATIONAL_MM_AGENT } from '@fruitful/llm-service-shared';
import { type OnboardingChatResults } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

interface MastraThread {
    id: string;
    mastraThreadId: string;
    membershipId: string | null;
    userId: string | null;
    visitorId: string | null;
    agentId: string;
    version: string;
    results: OnboardingChatResults | null;
    createdAt: string;
    updatedAt: string;
}

const useGetMembershipMastraThreads = requestBuilder.query<
    MastraThread[],
    { membershipId: string }
>({
    endpoint: ({ membershipId }) =>
        `/api/mastra-threads/membership/${membershipId}`,
    queryKey: ({ membershipId }) =>
        `getMembershipMastraThreads/${membershipId}`,
});

export const useGetMembershipMastraThread = ({
    membershipId,
}: {
    membershipId: string | null | undefined;
}) => {
    const result = useGetMembershipMastraThreads(
        { membershipId: membershipId ?? '' },
        { enabled: membershipId != null && membershipId !== '' },
    );

    return {
        ...result,
        data:
            result.data
                ?.filter((t) => t.agentId === CONVERSATIONAL_MM_AGENT.id)
                .sort(
                    (a, b) =>
                        new Date(b.updatedAt).getTime() -
                        new Date(a.updatedAt).getTime(),
                )[0]?.results ?? null,
    };
};
